/* eslint-disable no-mixed-operators */
import { PortalContext } from "../../../context/Provider";
import { useContext } from "react";
import AlertIcon from "../../../assets/images/generico/AlertIcon";
import Tooltip from "../../../../global/component/Genericos/Tooltip/Tooltip";
import "./CardTurnoAlerts.css";
import CirculoTildeOk from "../../../assets/images/generico/CirculoTildeOk";

const CardTurnoAlerts = ({ turno }) => {
  const {
    textosState,
  } = useContext(PortalContext);

  const alerts = [];

  if (turno.preparacion && turno.requiereAutorizacion) {
    alerts.push({ label: "Requiere Autorizacion", color: "c-danger", icon: <AlertIcon color={"var(--color-danger)"} width="20" height="20" />, tooltip: textosState.textos.data.reqAutorizacion.descripcion });
  }

  if (turno.flgSaldada) {
    alerts.push({ label: "Turno abonado", color: "c-broccoli", icon: <CirculoTildeOk width="20" height="20" /> });
  }

  if (turno.estadoOrden === "Pendiente" && turno.tieneFotoOrden) {
    alerts.push({ label: "Orden médica en verificación", color: "c-latex30", icon: <AlertIcon color={"var(--color-latex30)"} width="20" height="20" />, tooltip: "Luego de la verificación, su estudio podría tener un costo" });
  }

  if (turno.estadoOrden === "Rechazado") {
    alerts.push({ label: "Orden médica rechazada", color: "c-danger", icon: <AlertIcon color={"var(--color-danger)"} width="20" height="20" />, tooltip: turno.motivoRechazoObservacion });
  }

  if (turno.estadoOrden === "Validado") {
    alerts.push({ label: "Orden médica verificada", color: "c-broccoli", icon: <CirculoTildeOk width="20" height="20" /> });
  }

  if (turno.medSolicitanteDto && turno.subeFotoOrden) {
    alerts.push({ label: "Médico solicitante ingresado", color: "c-broccoli", icon: <CirculoTildeOk width="20" height="20" /> });
  }

  if (alerts.length === 0) {
    return null;
  }
  return <div className="ptur-card-cardTurno-alerts">
    {alerts.map(alert => <div className="ptur-alert">
      {alert?.tooltip && <Tooltip
        descripcion={alert.tooltip}
        data={
          <div className={`message ${alert.color}`}>
            {alert.icon}
            <span>{alert.label}</span>
          </div>
        }
      />}
      {!alert?.tooltip && <div className={`ptur-alert ${alert.color}`}>
        {alert.icon}
        <span>
          {alert.label}
        </span>
      </div>}
    </div>
    )}
  </div>
};

export default CardTurnoAlerts;
